import { Page } from './page';

export class DeletePage extends Page {
}
